function makeScrollable({ containerId }) {
  const container = document.getElementById(containerId);
  let isDragging = false;
  let startPosition = 0;
  let startScrollLeft = 0;

  if (container) {
    container.addEventListener("mousedown", (e) => startDragging(e));
  }

  document.addEventListener("mouseup", () => stopDragging());
  document.addEventListener("mousemove", (e) => drag(e));

  function startDragging(e) {
    isDragging = true;
    startPosition = e.clientX;
    startScrollLeft = container.scrollLeft;
  }

  function drag(e) {
    if (!isDragging) return;
    const delta = e.clientX - startPosition;
    container.scrollLeft = startScrollLeft - delta;
  }

  function stopDragging() {
    isDragging = false;
  }
}

// function onOpenDrawer() {
//   document.documentElement.style.overflow = "hidden";
//   const drawer = document.getElementById("byteex_cart_drawer");
//   if (drawer) {
//     drawer.style.display = "block";
//   }
// }
